export const reducerCases = {
  IS_SHOW_CUSTOM_COLUMNS: 'IS_SHOW_CUSTOM_COLUMNS',
}
